/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrderResponseDataSpecialServiceRequestsInner } from './getOrderResponseDataSpecialServiceRequestsInner';
import { GetOrderResponseDataTravelDocumentsInner } from './getOrderResponseDataTravelDocumentsInner';
import { GetOrderResponseDataTravelDocumentsSummary } from './getOrderResponseDataTravelDocumentsSummary';
import { GetOrderResponseDataLinkedOrdersInner } from './getOrderResponseDataLinkedOrdersInner';
import { GetOrderResponseDataPaymentRecordsInner } from './getOrderResponseDataPaymentRecordsInner';
import { GetOrderResponseDataAir } from './getOrderResponseDataAir';
import { GetOrderResponseDataServices } from './getOrderResponseDataServices';
import { GetOrderResponseDataOrderEligibilities } from './getOrderResponseDataOrderEligibilities';
import { GetOrderResponseDataServicingPointOfSale } from './getOrderResponseDataServicingPointOfSale';
import { GetOrderResponseDataContacts } from './getOrderResponseDataContacts';
import { GetOrderResponseDataSeats } from './getOrderResponseDataSeats';
import { GetOrderResponseDataSpecialKeywordsInner } from './getOrderResponseDataSpecialKeywordsInner';
import { GetOrderResponseDataNextActions } from './getOrderResponseDataNextActions';
import { GetOrderResponseDataOrderType } from './getOrderResponseDataOrderType';
import { GetOrderResponseDataPassengerSupport } from './getOrderResponseDataPassengerSupport';
import { GetOrderResponseDataServiceSummary } from './getOrderResponseDataServiceSummary';
import { GetOrderResponseDataTravelersSummary } from './getOrderResponseDataTravelersSummary';
import { GetOrderResponseDataCreationPointOfSale } from './getOrderResponseDataCreationPointOfSale';
import { GetOrderResponseDataMiscAncillariesInner } from './getOrderResponseDataMiscAncillariesInner';
import { Traveler } from './traveler';
import { GetOrderResponseDataPrices } from './getOrderResponseDataPrices';
import { GetOrderResponseDataAnaBizTicketingRequestsInner } from './getOrderResponseDataAnaBizTicketingRequestsInner';
import { GetOrderResponseDataTasks } from './getOrderResponseDataTasks';

/**
 * PNR情報
 */
export interface GetOrderResponseData {
  /**
   * 予約番号(英数字6桁)
   */
  orderId?: string;
  /**
   * criteoに連携するためのトランザクションID<br/> 現在日付(GMT、yyyyMMdd形式)＋orderIdを(暗号化したもの)を返却する。<br/> ※G03_共通処理（514_暗号化）を用いてBlowfish形式にて暗号化したものをbase64形式でエンコードを行う<br/> ※暗号化キーは設定ファイルにて管理する。<br/>
   */
  criteoTransactionId?: string;
  /**
   * SK LKRLにて紐づけられた関連する予約リスト<br/> ※搭乗者姓名がSK LKRLのフリーテキストに登録されているものをASWにて紐づけされた予約とみなし、その予約のリストを返却する。
   */
  linkedOrders?: Array<GetOrderResponseDataLinkedOrdersInner>;
  /**
   * 購入・発券状態<br/> unpurchased：未購入。<br/> 以下のいずれかを満たす<br/> 1 以下の全てに該当する<br/> 1-1 特典の減算を除く航空券のFPエレメントが何も存在しない<br/> 1-2 航空券が発券されているセグメント/搭乗者(※2)が1つもない<br/> 2 航空券のFPエレメントが存在する場合で、以下のいずれかを満たす<br/> 2-1 支払方法がクレジットカードかつ、未承認のものが存在する<br/> 2-2 支払方法が代替ペイメント(PayPal、銀聯、Alipay)かつ、未承認のものが存在する<br/> paymentAccepted：支払受付中。特典の減算を含む航空券のFPエレメントについて、以下を全て満たすものがある<br/> 1 FPエレメントのFOPコードがWBCASHまたはWCCASHである(DxAPIからはidとして返却されるコード)<br/> 2 払込期限(※1)が存在し、現在時刻を過ぎていない<br/> unticketed：未発券。未購入、支払受付中、発券申請中以外で、航空券が発券されているセグメント/搭乗者(※2)が1つもない<br/> applyingForTicketing：発券申請中。以下の全てに該当する<br/> 1.発券要求情報にて、発券申請中とされている<br/> ticketed：発券済み。上記以外<br/>  ※1 FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの4番目に払込期限がyyyyMMddHHmmss形式で返却される。<br/> ※2 航空券が発券されているセグメント/搭乗者とは、次のいずれかの状態を指す<br/> 1 ステータスが発券済みのFAエレメントが存在<br/> 2 FAエレメントが無く、FHEエレメントのみ存在
   */
  orderStatus?: GetOrderResponseData.OrderStatusEnum;
  nextActions?: GetOrderResponseDataNextActions;
  orderEligibilities?: GetOrderResponseDataOrderEligibilities;
  creationPointOfSale?: GetOrderResponseDataCreationPointOfSale;
  servicingPointOfSale?: GetOrderResponseDataServicingPointOfSale;
  air?: GetOrderResponseDataAir;
  prices?: GetOrderResponseDataPrices;
  /**
   * 運賃情報
   */
  fares?: object;
  /**
   * 企業が利用可能なCommercial Fare Familyコードリスト<br/> ANA Bizログイン済みの場合に、以下に従って返却する<br/> 1.フリーテキストが\"SYS-ANABIZ-CFF\"で始まるRMエレメントが登録されている場合、それを\"/\"(スラッシュ)で分割したリストを返却する<br/> 2.上記以外、かつ契約形態が\"P\"以外の場合、S2パーソナライズ報情(企業情報A票)より企業が利用可能なCommercial Fare Familyコードリストを取得し返却する<br/> 3.上記以外の場合、S2パーソナライズ情報(企業精算情報(C票))より企業が利用可能なCommercial Fare Familyコードリストを取得し返却する
   */
  commercialFareFamilyCodes?: Array<object>;
  /**
   * 積算マイル数（1PAXあたり）<br/> 全てのセグメントがOPEN便でない、かつ販売キャリアがNHグループの場合に返却する。<br/> マイル数は、OPEN便を除いたNHグループ便名のセグメントを対象に基本マイル×マイル積算率にて算出し小数点以下切り捨てを行い、その合算値を積算マイル数とする。ただし、対象セグメントの運航キャリアにASWDB(マスタ)の積算マイル表示対象外キャリアを1便でも含んでいた場合、もしくは積算マイル算出に必要な情報が不足している場合には、積算マイル計算不可として、当項目を返却しない。<br/> ※基本マイル：ASWDB(マスタ)より、当該セグメントの出発・到着空港をキーに取得する<br/> ※マイル積算率：<br/>   1 国際旅程・国際区間の場合<br/>     ASWDB(マスタ)より、当該セグメントのキャリアコードとブッキングクラスをキーに取得する。ただし、NHグループ運航便以外の場合には、ASWDB(マスタ)より、便番号・ブッキングクラスを元に、曜日毎の変換後ブッキングクラスを取得し、変換後のブッキングクラスを用いて積算率を取得する。<br/>   2 国際旅程・国内区間または国内単独旅程・出発日が国内DCS移行開始日(設定ファイルに定義)より前の場合<br/>     設定ファイルより、当該セグメントのブッキングクラスを元に取得する<br/>   3 国内単独旅程・出発日が国内DCS移行開始日(設定ファイルに定義)以降の場合<br/>     ASWDB（マスタ）より、MINDSから連携されたFarebasisを元に取得する。ただし、ファーストクラスの場合、ASWDB（マスタ）から取得したレートに50％上乗せして返却する。<br/> ※アップグレード済み、またはアップグレード前のセグメントが存在する場合、下位クラスのセグメントを対象セグメントとする。ただし、PUPG、またはBid My Priceでアップグレード済の場合、アップグレード前のセグメントが存在しないことから、下位クラスを特定できないため、当該PNRの積算マイル合計の算出は不可とし返却しない。<br/> ※PUPGアップグレード空席待ちの場合は、下位クラスのセグメントを特定できるため、積算マイルは返却される。<br/> ※Fare Basisが以下のいずれかの条件を満たす場合も算出不可とし、返却しない。<br/> 1.Fare Basisの2桁目以降に運賃表示対象外FareBasis(設定ファイルに定義)が含まれる<br/> 2.以下の全ての条件に合致する<br/>  2.1.特典PNR区分がfalse<br/>  2.2.旅程区分が日本国内単独旅程(domestic)である<br/>  2.3.第1便の出発日が国内DCS移行開始日(設定ファイルに定義)以降である<br/>  2.4.Fare Basisの7桁目に参院選挙用運賃Fare Basis(設定ファイルに定義)が含まれる
   */
  accuralMiles?: number;
  contacts?: GetOrderResponseDataContacts;
  /**
   * 搭乗者情報（幼児含む）リスト
   */
  travelers?: Array<Traveler>;
  /**
   * マイレージプログラム情報
   */
  frequentFlyerCards?: object;
  /**
   * 搭乗者情報系サポート
   */
  travelerSupports?: object;
  passengerSupport?: GetOrderResponseDataPassengerSupport;
  seats?: GetOrderResponseDataSeats;
  services?: GetOrderResponseDataServices;
  orderType?: GetOrderResponseDataOrderType;
  tasks?: GetOrderResponseDataTasks;
  /**
   * DxAPIから返却されたLast Ticketing Date(LTD)　(yyyy-MM-dd\'T\'HH:mm:ss形式)
   */
  ticketingDeadline?: string;
  /**
   * DxAPIから返却されたpaymentTimeLimit(OPC)を返却する。　(yyyy-MM-dd\'T\'HH:mm:ss形式)<br/> 但し、DxAPIから返却されない場合は\"\"(空文字)を設定する。<br/> ※購入発券APIでPNR購入不可チェック処理をスキップする条件の1つとして用いられる。
   */
  paymentTimeLimit?: string;
  /**
   * コールセンター問い合わせを伴う運賃再計算エラーが発生しているかどうか<br/> DxAPIから運賃再計算ができなかった旨のエラーが返却された場合にtrue
   */
  isRepricingFailedWithCallCenterContact?: boolean;
  travelersSummary?: GetOrderResponseDataTravelersSummary;
  serviceSummary?: GetOrderResponseDataServiceSummary;
  /**
   * ドキュメント情報リスト
   */
  travelDocuments?: Array<GetOrderResponseDataTravelDocumentsInner>;
  travelDocumentsSummary?: GetOrderResponseDataTravelDocumentsSummary;
  /**
   * FP情報リスト
   */
  paymentRecords?: Array<GetOrderResponseDataPaymentRecordsInner>;
  /**
   * SK情報リスト<br/> ※配下の項目はいずれもDxAPIから返却された同名の項目をそのまま返却する。<br/> ※別APIからの内部呼び出しの場合に当項目を返却する。予約詳細画面表示時のように、当APIが外部から呼び出された場合はこの情報は返却しない。
   */
  specialKeywords?: Array<GetOrderResponseDataSpecialKeywordsInner>;
  /**
   * SSR情報リスト<br/> ※配下の項目はいずれもDxAPIから返却された同名の項目をそのまま返却する。<br/> ※SK情報リストと同様、内部呼び出しの場合にのみ当項目を返却する。
   */
  specialServiceRequests?: Array<GetOrderResponseDataSpecialServiceRequestsInner>;
  /**
   * 座席とサービス以外のEMD情報リスト<br/> ※差額払戻EMDなどが返却される。
   */
  miscAncillaries?: Array<GetOrderResponseDataMiscAncillariesInner>;
  /**
   * 株主優待情報<br/> ※FDエレメントに登録されている株主優待情報を返却する。<br/> ※別APIからの内部呼び出しの場合に当項目を返却する。予約詳細画面表示時のように、当APIが外部から呼び出された場合はこの情報は返却しない。
   */
  shareholderCoupons?: object;
  /**
   * ANA Biz発券要求情報
   */
  anaBizTicketingRequests?: Array<GetOrderResponseDataAnaBizTicketingRequestsInner>;
}
export namespace GetOrderResponseData {
  export type OrderStatusEnum = 'unpurchased' | 'paymentAccepted' | 'unticketed' | 'applyingForTicketing' | 'ticketed';
  export const OrderStatusEnum = {
    Unpurchased: 'unpurchased' as OrderStatusEnum,
    PaymentAccepted: 'paymentAccepted' as OrderStatusEnum,
    Unticketed: 'unticketed' as OrderStatusEnum,
    ApplyingForTicketing: 'applyingForTicketing' as OrderStatusEnum,
    Ticketed: 'ticketed' as OrderStatusEnum,
  };
}
